var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaylist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632892899196,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1370,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M554.666667 703.701333C554.666667 786.218667 621.781333 853.333333 704.298667 853.333333s149.632-67.114667 149.632-149.632c0-7.552-1.152-14.805333-2.261334-22.058666H853.333333V256h85.333334V170.666667h-128a42.666667 42.666667 0 0 0-42.666667 42.666666v355.541334a147.84 147.84 0 0 0-63.701333-14.762667A149.76 149.76 0 0 0 554.666667 703.701333z m149.632-64.298666c35.456 0 64.298667 28.842667 64.298666 64.298666S739.754667 768 704.298667 768 640 739.157333 640 703.701333s28.842667-64.298667 64.298667-64.298666zM85.333333 213.333333h597.333334v85.333334H85.333333z",
    fill: "",
    "p-id": 1371
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.333333 384h597.333334v85.333333H85.333333z m0 170.666667h384v85.333333H85.333333z m0 170.666666h384v85.333334H85.333333z",
    fill: "",
    "p-id": 1372
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.ed2f36dc.svg";
export { ForwardRef as ReactComponent };